
        import '/mnt/ssd/na101/home/literatum/sourcegit/ui-products-branches/maint-260203-36a4996a/ui-products/wspc/node_modules/ui-core/plugins/drawer/js/drawer';
  
import '/mnt/ssd/na101/home/literatum/sourcegit/ui-products-branches/maint-260203-36a4996a/ui-products/wspc/plugins/slide/js/slide';
  
import '/mnt/ssd/na101/home/literatum/sourcegit/ui-products-branches/maint-260203-36a4996a/ui-products/wspc/node_modules/ui-core/widgets/menu/js/responsive-menu';
  
const main = (UX) => {
    const $menu = Array.prototype.slice.call(document.querySelectorAll('[data-toggle="nav"]')),
        $slide = Array.prototype.slice.call(document.getElementsByClassName('w-slide__btn')),
        $reponsiveMenu = Array.prototype.slice.call(document.getElementsByClassName('responsive-menu-nav'))

try {
        if ($menu.length ) {
            UX.menu.init($menu);
        }
    } catch (err) {
        console.error(err);
    }
    
try {
        if ($slide.length ) {
            UX.slide.init($slide);
        }
    } catch (err) {
        console.error(err);
    }
    
try {
        if ($reponsiveMenu.length ) {
            UX.reponsiveMenu.init($reponsiveMenu);
        }
    } catch (err) {
        console.error(err);
    }
    
}

        export default main;
        